module.exports = __webpack_public_path__ + "static/media/matCutter.ae805b9d.PNG";